import { Injectable } from '@angular/core';
import {environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EncrDecrService } from '../../services/encr-decr.service';


@Injectable({
  providedIn: 'root'
})
export class SponsoredEventsService {

  constructor(private http: HttpClient,
    private EncDecrService: EncrDecrService) { } 

  getAllSponsoredEvents() {

    return this.http.post(environment.apiURI + 'admin/sponsored/all', {"start_date":"", "end_date":""}).toPromise()
  }

}